import { Component } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'formly-spinner',
    template: ` <mat-spinner [diameter]="to?.diameter || 30"></mat-spinner> `,
    standalone: true,
    imports: [MatProgressSpinnerModule],
})
export class FormlySpinnerComponent extends FieldType {}
